import clsx from 'clsx'
import React from 'react'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

interface TShowKeywordButtonProps {
  setIsKeywordActive: (value: boolean) => void
  subject: string
}

export const ShowKeywordButton = ({
  setIsKeywordActive,
  subject,
}: TShowKeywordButtonProps) => {
  return (
    <div
      onClick={() => setIsKeywordActive(true)}
      className={clsx(
        'mb-6 flex cursor-pointer items-center gap-x-2 !pl-0 !font-semibold',
        !subject ? 'pointer-events-none cursor-not-allowed opacity-40' : ''
      )}
    >
      <span className="flex h-5 w-5 items-center justify-center rounded-full bg-icon-informational">
        <Icon fontSize="sm" color="inverse" className="bg-action ">
          add
        </Icon>
      </span>
      <Text color="primary" className="text-[15px] !font-semibold !underline">
        Cari materi spesifik
      </Text>
    </div>
  )
}

interface TKeywordInputProps {
  keyword: string
  setKeyword: (value: string) => void
  setIsKeywordActive: (value: boolean) => void
  isActiveToolkitTypeBahanAjar?: boolean
}

export const KeywordInput = React.forwardRef<
  HTMLInputElement,
  TKeywordInputProps
>((props, ref) => {
  const {
    keyword,
    setKeyword,
    setIsKeywordActive,
    isActiveToolkitTypeBahanAjar,
  } = props
  return (
    <span className="group flex h-[50px] w-full items-center justify-between rounded-[4px] border border-default px-4 py-3">
      <input
        ref={ref}
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        placeholder="Masukkan kata kunci"
        className="group-focus:outline-blue-530 w-full focus:outline-none"
      />
      <Icon
        className="cursor-pointer"
        onClick={() => {
          if (!isActiveToolkitTypeBahanAjar) setIsKeywordActive(false)
          setKeyword('')
        }}
      >
        {isActiveToolkitTypeBahanAjar && keyword.length === 0
          ? 'search'
          : 'close'}
      </Icon>
    </span>
  )
})

KeywordInput.displayName = 'KeywordInput'
